module.exports = __webpack_public_path__ + "img/06.d4c40767.png";